import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Langs} from '@affluences/lb-types';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

export interface DialogData {
    endpoints: any
}


@Component( {
    selector: 'app-desktop-dialog-select-endpoint',
    templateUrl: './dialog-select-endpoint.component.html',
    styleUrls: ['./dialog-select-endpoint.component.scss']
} )
export class DialogSelectEndpointComponent implements OnInit {



    constructor(
        public dialogRef: MatDialogRef<DialogSelectEndpointComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        @Inject( L10N_LOCALE ) public locale: L10nLocale
    ) {}

    ngOnInit(): void {
        console.log(this.data)
    }

    onConfirm ( endpointId ): void {
        this.dialogRef.close( { res: true, endpointId: endpointId } )
    }

    onCancel (): void {
        this.dialogRef.close( { res: false } )
    }

}
